export default async function adfsAuth({
  next,
  store,
  to,
  nextMiddleware
}) {
  const tk = to.query.tk
  const dispatch = store.dispatch

  if (tk) {
    try {
      await dispatch('auth/loginBy', { tk })
      next({ name: 'projects' })
    } catch (e) {
      return next(false)
    }
  }

  return nextMiddleware()
}
